/**
 * Usage:
 *
 * Step 1: Somewhere in JS...
 *   import Alpine from "alpinejs";
 *   import spine from "./typicalModal";
 *   Alpine.data('typicalModal', typicalModal);
 *   Alpine.start();
 *
 * Step 2: Somewhere in markup...
 *   <div x-data="typicalModal()" />
 *
 * @param selector
 */
import Swiper from 'swiper';
import 'swiper/css/bundle';
import {Manipulation, Navigation} from 'swiper/modules';

Swiper.use([Manipulation, Navigation]);

export default () => ({

  fileDropdownOpen: false,
  planningIdeaModalOpen: false,
  title: '',
  description: '',
  downloads: [],
  images: [],
  selectedAssets: [],
  swiper: null,
  options: {
    slidesPerView: 1,
    spaceBetween: 20,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  },

  init() {
    if (this.swiper !== null) {
      return;
    }
    this.swiper = new Swiper(this.$refs.swiper, this.options);
  },

  openModal(title = '', downloadableAssets = [], images = [], description = '') {
    this.planningIdeaModalOpen = true;
    this.title = title;
    this.description = description;
    this.downloads = downloadableAssets;
    this.images = images;

    this.$nextTick(() => {

      if (this.images.length && this.swiper && !this.swiper.destroyed) {
        this.images.forEach((image) => {
          this.swiper.appendSlide(`<div class="swiper-slide bg-blend-multiply bg-contain bg-no-repeat bg-center bg-silver-light" title="${JSON.parse(image.alt)}" style="background-image: url('${image.url}')"></div>`);
        });
        this.swiper.update();
      }
    });
  },

  reset() {
    this.planningIdeaModalOpen = false;
    this.title = '';
    this.description = '';
    this.downloads = [];
    this.images = [];
    this.selectedAssets = [];
    this.fileDropdownOpen = false;

    this.$nextTick(() => {
      if (this.swiper) {
        this.swiper.removeAllSlides();
        this.swiper.update();
      }
    });

  }

});